import RateButton from './RateButton'

export default RateButton
